import type { TemplateLayoutSummary } from "@/types/template-layout/templateLayout.types";

export const TEMPLATE_CREATE_PATH = "/scheduled-briefings/templates/create";

/** Fields that decide whether `templates/$templateId` opens Template Studio vs locked preview. */
export type TemplateStudioEntrySummary = Pick<
  TemplateLayoutSummary,
  "canEdit" | "briefingCount" | "status"
>;

/**
 * True when the user may edit this template in Template Studio from the detail URL.
 * Requires `can-create-templates`, ownership, no briefings using the layout, and
 * an active template (the backend rejects updates to archived ones). Everything
 * else can still be duplicated.
 */
export const canOpenTemplateInTemplateStudio = (
  template: TemplateStudioEntrySummary,
  canCreateTemplates: boolean,
): boolean =>
  canCreateTemplates &&
  template.canEdit &&
  template.briefingCount === 0 &&
  template.status !== "archived";

/** Default name shown in the Save dialog when duplicating a template (create-on-save). */
export const duplicateTemplateDefaultName = (sourceName: string): string =>
  `${sourceName} [COPY]`;
